import { Check } from 'lucide-react';

// Green "Verification successful!" end screen (designer: SuccessScreen).
// Shared by the builder preview and the live session runtime.
export function SuccessScreen() {
  return (
    <div className="flex h-full flex-col items-center justify-center px-4 pb-8 pt-16 text-center">
      <div className="mb-6 flex h-[120px] w-[120px] items-center justify-center rounded-full bg-[#00A92C]">
        <Check size={64} strokeWidth={3} color="white" />
      </div>
      <h2 className="mb-2 text-[length:var(--text-20)] font-semibold leading-tight text-[#00A92C]">
        Verification successful!
      </h2>
      <p className="text-[length:var(--text-14)] text-[#666666]">
        You can continue without any further action.
      </p>
    </div>
  );
}
